import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Code.module.scss';
import clsx from 'clsx';
import { Tooltip } from 'react-tooltip';
const Code = ({ children }) => {
  const [hover, setHover] = useState(false);
  const [copied, setCopied] = useState(false);
  return (
    <>
      <div
        className={clsx(styles.wrap)}
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
        }}>
        <code className={clsx(styles.code)}>{children}</code>
        <div
          className={clsx(styles.copy, (hover || copied) && styles.copyShow)}
          data-tooltip-id="tooltip-popup"
          data-tooltip-content="Скопировано"
          data-tooltip-place="top"
          onClick={() => {
            navigator.clipboard.writeText(children);
            setCopied(true);
            setTimeout(() => {
              setCopied(false);
            }, 1000);
          }}>
          {copied ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-copy">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
          )}
        </div>
        <Tooltip id="tooltip-popup" isOpen={copied} />
      </div>
    </>
  );
};

export default Code;
